import { getAllCrews } from '@/api/crews';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { handleAPIError } from '@/utils/errorHandler';
import { useAuth } from '@/providers/AuthProvider';
import { getUsers, UserFilters } from '@/api/users';

export const useUsers = (filters?: UserFilters) => {
  const { organization } = useAuth();
  const orgId = organization?.id;

  const query = useQuery({
    queryKey: ['users', orgId, filters],
    queryFn: () => getUsers(filters),
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    users: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
};
